<template>
  <div class="sidebar-pinned">
    <aside class="admin-sidebar"
      :class="{ 'sidebar--pinned': sidebarPinned, 'sidebar--mobile-open': mobileSidebarOpen }">
      <div class="admin-sidebar-brand">
        <!-- begin sidebar branding-->
        <img class="admin-brand-logo" src="/assets/img/ohis_logo.png" width="40" alt="RIVCHPP Logo"
          onerror="this.onerror=null; this.src='/assets/img/ohis_logo.png'" />
        <!-- end sidebar branding-->
        <div class="ml-auto brand-controls">
          <!-- sidebar pin-->
          <a href="#" class="admin-pin-sidebar btn-ghost btn btn-rounded-circle"
            @click.prevent="sidebarPinned = !sidebarPinned"
            :title="sidebarPinned ? 'Unpin sidebar' : 'Pin sidebar open'"></a>
          <!-- sidebar close for mobile device-->
          <a href="#" class="admin-close-sidebar"></a>
        </div>
      </div>
      <div class="admin-sidebar-wrapper js-scrollbar">
        <ul class="menu">
          <!-- Staff with the "dashboard" job title (display account): only their dashboard -->
          <template v-if="dashboardOnly">
            <li class="menu-item active">
              <router-link to="/dashboard-view" class="menu-link">
                <span class="menu-label">
                  <span class="menu-name">Dashboard </span>
                </span>
                <span class="menu-icon">
                  <i class="icon-placeholder fe fe-home"></i>
                </span>
              </router-link>
            </li>
            <li class="menu-item" v-if="chatEnabled">
              <router-link to="/messages" class="menu-link">
                <span class="menu-label">
                  <span class="menu-name">Messages <span v-if="chatUnread > 0" class="badge badge-pill badge-danger ml-1">{{ chatUnread }}</span></span>
                </span>
                <span class="menu-icon">
                  <i class="icon-placeholder fe fe-message-square"></i>
                </span>
              </router-link>
            </li>
          </template>
          <template v-else>
          <li class="menu-item active" v-if="user.type == 'client'">
            <router-link to="/client-dashboard" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">Dashboard </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-home"></i>
              </span>
            </router-link>
          </li>

          <li class="menu-item active" v-if="user.type == 'tpa'">
            <router-link to="/tpa-dashboard" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">Dashboard </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-home"></i>
              </span>
            </router-link>
          </li>

          <li class="menu-item active" v-if="user.type == 'tpa_employee'">
            <router-link to="/tpa-employee-dashboard" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">Dashboard </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-home"></i>
              </span>
            </router-link>
          </li>

          <li class="menu-item active" v-if="user.type == 'hmo'">
            <router-link to="/hmo-dashboard" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">Dashboard </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-home"></i>
              </span>
            </router-link>
          </li>

          <li class="menu-item active" v-if="user.type == 'shis' || user.user_role == 1">
            <a href="/state-dashboard" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">Dashboard </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-home"></i>
              </span>
            </a>
          </li>

          <li class="menu-item active" v-if="user.type == 'employee' && user.user_role == 0">
            <a href="/employee-dashboard" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">Dashboard </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-home"></i>
              </span>
            </a>
          </li>

          <li class="menu-item" v-if="user.type == 'provider_employee'">
            <a href="/personnel" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">My Dashboard </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-home"></i>
              </span>
            </a>
          </li>

          <li class="menu-item" v-if="user.type == 'hmo'">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">Clients
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-users"></i>
              </span>
            </a>
            <!--submenu-->
            <ul class="sub-menu">
              <li class="menu-item">
                <router-link to="/add-client-agency" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Add Client </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-edit"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item">
                <router-link to="/view-clients-agency" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">View Clients </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-view-day"></i>
                  </span>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="menu-item" v-if="user.type == 'provider' || user.type == 'provider_employee'">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">Facility Data
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-airplay"></i>
              </span>
            </a>
            <!--submenu-->
            <ul class="sub-menu">
              <li class="menu-item">
                <router-link to="/provider-dashboard" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Facility Dashboard </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-bar-chart-2"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item">
                <router-link to="/view-clients-provider" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">View Enrollees </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-account-group-outline"></i>
                  </span>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="menu-item" v-if="
              user.type == 'employee' ||
              user.type == 'tpa' ||
              user.type == 'tpa_employee' ||
              user.type == 'shis'
            ">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">Clients
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-users"></i>
              </span>
            </a>
            <!--submenu-->
            <ul class="sub-menu">
              <li class="menu-item">
                <a href="/add-client-agency" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Add Enrollee (Informal) </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-account-multiple-plus"></i>
                  </span>
                </a>
              </li>
              <li class="menu-item">
                <a href="/add-client-formal" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Add Enrollee (Formal) </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-user-plus"></i>
                  </span>
                </a>
              </li>

              <li class="menu-item">
                <a href="/voluntary-registration-form" class="menu-link" target="_blank">
                  <span class="menu-label">
                    <span class="menu-name">Voluntary Enrollment</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-user-plus"></i>
                  </span>
                </a>
              </li>

              <!-- <li class="menu-item">
                <router-link to="/add-client-offline" class=" menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Add Enrollees(Offline) </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-cloud-off"></i>
                  </span>
                </router-link>
              </li> -->
              <li class="menu-item" v-if="user.type == 'employee'">
                <a href="/manage-clients" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Manage Enrollees </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-users"></i>
                  </span>
                </a>
              </li>

              <li class="menu-item">
                <a href="/add-client/employee-offline" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Offline Management </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-cloud-off"></i>
                  </span>
                </a>
              </li>

              <li class="menu-item" v-if="user.type == 'employee'">
                <a href="/change-facility-requests" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Change Facility Requests</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-paper-clip"></i>
                  </span>
                </a>
              </li>

              <li class="menu-item" v-if="user.type == 'employee' || user.type == 'shis'">
                <a href="/view-clients-agency" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">View Clients </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-account-group-outline"></i>
                  </span>
                </a>
              </li>

              <li class="menu-item">
                <router-link to="/transfer-of-hcp" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">COF Form </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-bank-transfer"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item">
                <router-link to="/enrollee-feedback" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Enrollee Feedback</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-message"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item">
                <a href="/manage-extra" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Manage Expiries </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-view-day"></i>
                  </span>
                </a>
              </li>

              <li class="menu-item">
                <router-link to="/export-date" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Export Enrollee</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-file"></i>
                  </span>
                </router-link>
              </li>
            </ul>
          </li>

          <!-- Providers -->
          <li class="menu-item" v-if="user.type == 'shis' || user.user_role == 1">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">Providers
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-home"></i>
              </span>
            </a>
            <!--submenu-->
            <ul class="sub-menu">
              <li class="menu-item">
                <router-link to="/providers/dashboard" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Provider Dashboard</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-bar-chart-2"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item">
                <router-link to="/my-providers" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Health Facilities</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-list"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item">
                <router-link to="/my-providers?add=1" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Add Facility</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-plus-circle"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item">
                <router-link to="/providers/zero-enrollees" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Zero-Enrollee Facilities</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-slash"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item">
                <router-link to="/facility-risk" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Facility Risk</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-alert-triangle"></i>
                  </span>
                </router-link>
              </li>
            </ul>
          </li>

          <!-- Establishments -->
          <li class="menu-item" v-if="user.type == 'shis' || user.user_role == 1">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">Establishments
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-briefcase"></i>
              </span>
            </a>
            <!--submenu-->
            <ul class="sub-menu">
              <li class="menu-item">
                <router-link to="/establishments/dashboard" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Establishment Dashboard</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-bar-chart-2"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item">
                <router-link to="/mda-manager" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">All Establishments</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-list"></i>
                  </span>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="menu-item" v-if="user.type == 'client'">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">Dependents
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-users"></i>
              </span>
            </a>
            <!--submenu-->
            <ul class="sub-menu">
              <li class="menu-item">
                <router-link to="/add-dependents" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Add Dependents </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-edit"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item">
                <router-link to="/my-dependents" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">View Dependents </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-view-day"></i>
                  </span>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="menu-item" v-if="user.type == 'hmo'">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">HR Management
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-briefcase"></i>
              </span>
            </a>
            <!--submenu-->
            <ul class="sub-menu">
              <li class="menu-item">
                <router-link to="/add-employee" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Add Employee </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-edit"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item">
                <router-link to="/my-employees" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">My Employees </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-view-day"></i>
                  </span>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="menu-item" v-if="user.type == 'shis' || user.user_role == 1">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">HR Management
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-briefcase"></i>
              </span>
            </a>
            <!--submenu-->
            <ul class="sub-menu">
              <li class="menu-item">
                <a href="/add-employee-state" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Add Employee </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-edit"></i>
                  </span>
                </a>
              </li>

              <li class="menu-item">
                <a href="/my-employees" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">My Employees </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-view-day"></i>
                  </span>
                </a>
              </li>

              <li class="menu-item">
                <router-link to="/all-activities" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Activity Logs </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-eye-settings"></i>
                  </span>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="menu-item" v-if="user.type == 'provider'">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">HR Management
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-briefcase"></i>
              </span>
            </a>
            <!--submenu-->
            <ul class="sub-menu">
              <li class="menu-item">
                <router-link :to="{ path: '/provider/add-employee/' + user.id }" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Manage Employees </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-edit"></i>
                  </span>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="menu-item" v-if="user.user_role == 1 || user.job_title == 'Inter-state'">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">Inter-state Manager
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder mdi mdi-arrow-decision-outline"></i>
              </span>
            </a>
            <ul class="sub-menu">
              <li class="menu-item">
                <router-link to="/all-corridors" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">All Requests </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-hospital-marker"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item">
                <router-link to="/request-corridor" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">New Corridor</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-folder-plus"></i>
                  </span>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="menu-item" v-if="user.type == 'provider_employee'">
            <a href="/quality-assurance" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">M&E Manager </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-aperture"></i>
              </span>
            </a>
          </li>

          <li class="menu-item" v-if="
              user.type == 'employee' &&
              (user.job_title == 'M and E' || user.user_role != 0)
            ">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">M&E Manager
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-monitor"></i>
              </span>
            </a>
            <!--submenu-->
            <ul class="sub-menu">
              <li class="menu-item">
                <router-link to="/qa-dashboard" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Dashboard</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-home"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item" v-if="user.type == 'employee'">
                <router-link to="/accreditation-items" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">M&E Forms </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-check-circle"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item">
                <a href="/quality-assurance" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">M&E Manager </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-aperture"></i>
                  </span>
                </a>
              </li>
            </ul>
          </li>

          <li class="menu-item" v-if="
              user.type == 'shis' ||
              user.type == 'provider' ||
              user.type == 'provider_employee' ||
              user.user_role == 1 ||
              user.job_title == 'Claims Vetter' ||
              user.job_title == 'Claims Verifier'
            ">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">Claims Manager
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-grid"></i>
              </span>
            </a>
            <!--submenu-->
            <ul class="sub-menu">
              <li class="menu-item" v-if="user.job_title == 'Executive Secretary'">
                <router-link to="/all-claims-facility" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Approve Claims </span>
                  </span>

                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-edit"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item">
                <router-link to="/all-claims" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Manage Claims </span>
                  </span>

                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-file-document-outline"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item" v-if="user.type == 'employee'">
                <router-link to="/claims-statistics" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Claims Statistics </span>
                  </span>

                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-bar-chart-2"></i>
                  </span>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="menu-item" v-if="
              user.type == 'shis' ||
              user.type == 'provider' ||
              user.type == 'provider_employee' ||
              user.user_role == 1 ||
              user.job_title == 'Claims Vetter' ||
              user.job_title == 'Claims Verifier'
            ">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">Referrals Manager
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-grid"></i>
              </span>
            </a>
            <!--submenu-->
            <ul class="sub-menu">
              <li class="menu-item">
                <router-link to="/authorization-code-statistics" class="menu-link" v-if="user.type == 'employee'">
                  <span class="menu-label">
                    <span class="menu-name">Authorization Dashboard</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-bar-chart-2"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item">
                <router-link to="/authorization-code" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Authorization Code</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-anchor"></i>
                  </span>
                </router-link>
              </li>

              <!-- <li class="menu-item">
                <router-link to="/add-referral" class=" menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Add Referral </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-plus-box"></i>
                  </span>
                </router-link>
              </li> -->
              <li class="menu-item" v-if="user.type == 'provider_employee'">
                <router-link to="/all-referrals" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">View Referrals </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-bank-transfer-out"></i>
                  </span>
                </router-link>
              </li>

            </ul>
          </li>

          <li class="menu-item" v-if="(user.type == 'provider_employee' && user.user_role == 1) ||
              user.job_title == 'Finance' ||
              user.type == 'provider' ||
              user.job_title == 'Executive Secretary' ||
              user.type == 'shis'">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">Finance Manager
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-credit-card"></i>
              </span>
            </a>
            <!--submenu-->
            <ul class="sub-menu">
              <li class="menu-item" v-if="user.type == 'provider' || (user.type == 'provider_employee' && user.user_role == 1)">
                <router-link to="/payout-account" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Wallet &amp; Payout Account</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-briefcase"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item" v-if="user.type == 'provider' || (user.type == 'provider_employee' && user.user_role == 1)">
                <router-link to="/loans" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Business Loans</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-dollar-sign"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item" v-if="user.type == 'shis' || user.type == 'employee'">
                <router-link to="/online-payments" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Online Payments</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-send"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item" v-if="user.type != 'provider_employee'">
                <router-link to="/fund-manager" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Finance Dashboard </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-medical-bag"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item" v-if="user.type != 'provider_employee'">
                <router-link to="/payment-claims" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Claims' Payments </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-credit-card"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item" v-if="user.type != 'provider_employee'">
                <router-link to="/payment-capitations" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Capitations </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-credit-card"></i>
                  </span>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="menu-item" v-if="user.type == 'shis' || user.user_role == 1">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">Services Manager
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-box"></i>
              </span>
            </a>
            <!--submenu-->
            <ul class="sub-menu">
              <li class="menu-item">
                <router-link to="/my-encounters" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Encounters Management</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-medical-bag"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item">
                <router-link to="/encounter-statistics" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Encounter Statistics</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-bar-chart-2"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item">
                <router-link to="/manage-drugs" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Drugs manager </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-thermometer"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item">
                <router-link to="/manage-services" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Fee for Service </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-view-day"></i>
                  </span>
                </router-link>
              </li>

              <!-- <li class="menu-item">
                <router-link to="/service-summary-form" class=" menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Encounter Attendance Form </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-view-day "></i>
                  </span>
                </router-link>
              </li> -->
            </ul>
          </li>

          <li class="menu-item" v-if="(user.type == 'shis' || user.type == 'employee') && (user.job_title == 'M and E' || user.job_title == 'Call Centre' || user.job_title == 'Call Center' || user.job_title == 'Customer Care' || user.job_title == 'Customer Service' || user.type == 'shis' || user.user_role == 1 || user.job_title == 'Executive Secretary' || user.job_title == 'Director' || user.job_title == 'Claims Vetter' || user.job_title == 'Claims Verifier')">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">Reports
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-pie-chart"></i>
              </span>
            </a>
            <ul class="sub-menu">
              <li class="menu-item" v-if="user.type == 'shis' || user.user_role == 1 || user.job_title == 'Executive Secretary' || user.job_title == 'Director'">
                <router-link to="/executive-summary" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Executive Summary</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-briefcase"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item">
                <router-link to="/authorization-code-statistics" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Authorization Report</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-key"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item">
                <router-link to="/claims-statistics" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Claims Analysis</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-layers"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item">
                <router-link to="/disease-tracking" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Disease Tracking</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-thermometer"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item" v-if="user.type == 'shis' || user.user_role == 1">
                <router-link to="/system-health" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">System Health</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-heart"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item" v-if="user.type == 'shis' || user.user_role == 1 || user.job_title == 'Executive Secretary' || user.job_title == 'Director' || user.job_title == 'Claims Vetter' || user.job_title == 'Claims Verifier'">
                <router-link to="/facility-risk" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Facility Risk</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-alert-triangle"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item" v-if="user.type == 'shis' || user.user_role == 1">
                <router-link to="/audit-log" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Audit Log</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-shield"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item" v-if="user.type == 'shis' || user.user_role == 1 || user.job_title == 'Executive Secretary' || user.job_title == 'Director' || user.job_title == 'M and E'">
                <router-link to="/forecasts" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Forecasts &amp; Targets</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-activity"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item" v-if="user.type == 'shis' || user.user_role == 1 || user.job_title == 'Executive Secretary' || user.job_title == 'Director' || user.job_title == 'M and E'">
                <router-link to="/population" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Population &amp; Coverage</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-users"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item" v-if="user.type == 'shis' || user.user_role == 1 || user.job_title == 'Executive Secretary' || user.job_title == 'Director' || user.job_title == 'Call Centre' || user.job_title == 'Call Center' || user.job_title == 'Customer Care' || user.job_title == 'Customer Service'">
                <router-link to="/call-centre" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Call Centre</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-phone-call"></i>
                  </span>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="menu-item" v-if="user.type == 'shis' || user.user_role == 1">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">Others
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-external-link"></i>
              </span>
            </a>
            <!--submenu-->
            <ul class="sub-menu">
              <li class="menu-item">
                <router-link to="/manage-diagnosis" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Disease List </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-check-circle"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item">
                <router-link to="/quality-assurance" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">M&E Manager</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-check-square"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item">
                <router-link to="/change-facility-requests" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">COF Requests </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-bank-transfer"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item">
                <router-link to="/chat-with-hiva" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Chat with HIVA<sup>TM</sup> </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-message-circle"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item">
                <router-link to="/ward-manager" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Ward Manager </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-map-pin"></i>
                  </span>
                </router-link>
              </li>
              <li class="menu-item">
                <router-link to="/db-query" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">DB Admin </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-database"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item">
                <router-link to="/plans" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Plan Management </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-layers"></i>
                  </span>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="menu-item" v-if="user.type == 'hmo'">
            <router-link to="/my-providers" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">My Providers </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-activity"></i>
              </span>
            </router-link>
          </li>


          <!-- <li
            class="menu-item"
            v-if="user.type == 'shis' || user.user_role == 1"
          >
            <a href="/my-tpas" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">TPAs/ HMOs</span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-briefcase"></i>
              </span>
            </a>
          </li> -->

          <li class="menu-item" v-if="user.type == 'tpa'">
            <a href="/add-officers" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">Add Agents </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-briefcase"></i>
              </span>
            </a>
          </li>

          <li class="menu-item" v-if="user.type == 'tpa' || user.type == 'tpa_employee'">
            <a href="/all-claims" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">Claims Management </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder mdi mdi-view-day"></i>
              </span>
            </a>
          </li>

          <li class="menu-item" v-if="user.type == 'tpa' || user.type == 'tpa_employee'">
            <a href="/authorization-code" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">Authorization Code </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-anchor"></i>
              </span>
            </a>
          </li>


          <!-- <li class="menu-item" >
                <a href="/my-complaints" class=" menu-link">
                            <span class="menu-label">
                                    <span class="menu-name">Complaints/Inquiry
                                    </span>
                                  </span>
                            <span class="menu-icon">
                          <i class="icon-placeholder  fe fe-thumbs-down"></i>
                                </span>
                </a>
              </li> -->

          <li class="menu-item" v-if="user.type == 'client'">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">Complaints
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-thumbs-down"></i>
              </span>
            </a>
            <!--submenu-->
            <ul class="sub-menu">
              <li class="menu-item">
                <router-link to="/add-complaint" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Make Complaint </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-edit"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item">
                <router-link to="/my-complaints" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">View Complaints </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-view-day"></i>
                  </span>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="menu-item" v-if="user.type == 'client'">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">Complaints
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-thumbs-down"></i>
              </span>
            </a>
            <!--submenu-->
            <ul class="sub-menu">
              <li class="menu-item">
                <router-link to="/add-complaint" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Make Complaint </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-edit"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item">
                <router-link to="/my-complaints" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">View Complaints </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-view-day"></i>
                  </span>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="menu-item" v-if="user.type == 'provider' || user.type == 'provider_employee'">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">EMR
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-activity"></i>
              </span>
            </a>
            <!--submenu-->
            <ul class="sub-menu">
              <li class="menu-item" v-if="user.type == 'provider_employee'">
                <router-link to="/add-record" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Add Record </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-edit"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item" v-if="user.type == 'provider_employee'">
                <router-link to="/add-record-sec/secondary" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Add Record Secondary </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-edit"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item" v-if="user.type == 'provider_employee'">
                <router-link to="/add-record-offline" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Add Record Offline </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-cloud-off"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item">
                <router-link to="/list-records" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Patient Records </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-medical-bag"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item" v-if="user.type == 'provider_employee'">
                <router-link to="/offline-home" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Offline Records </span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder mdi mdi-cloud-sync"></i>
                  </span>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="menu-item" v-if="user.type == 'shis' || (user.type == 'employee' && user.user_role != 0)">
            <router-link to="/procurement/vendors" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">Vendors</span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder mdi mdi-nature-people"></i>
              </span>
            </router-link>
          </li>

          <li class="menu-item" v-if="user.type == 'shis' || (user.type == 'employee' && user.user_role != 0)">
            <router-link to="/marketplace/admin" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">Marketplace Vendors</span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-shopping-bag"></i>
              </span>
            </router-link>
          </li>

          <li class="menu-item"
            v-if="user.type == 'shis' || user.type == 'employee' || user.type == 'provider' || user.type == 'provider_employee'">
            <router-link to="/assessments" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">Assessments</span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-clipboard"></i>
              </span>
            </router-link>
          </li>

          <li class="menu-item"
            v-if="user.type == 'shis' || user.type == 'employee' || user.type == 'provider' || user.type == 'provider_employee'">
            <router-link to="/telemedicine" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">Telemedicine</span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-video"></i>
              </span>
            </router-link>
          </li>

          <li class="menu-item" v-if="user.type == 'provider' || user.type == 'provider_employee'">
            <router-link to="/manage-appointments" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">Appointments</span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder mdi mdi-calendar-clock"></i>
              </span>
            </router-link>
          </li>

          <li class="menu-item active" v-if="user.type == 'vendor_employee' || user.type == 'vendor_staff'">
            <router-link to="/vendor-employee-dashboard" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">Dashboard </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-home"></i>
              </span>
            </router-link>
          </li>

          <li class="menu-item"
            v-if="user.type == 'provider' || user.type == 'provider_employee' || user.type == 'vendor_employee' || user.type == 'vendor_staff'">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">Procurement
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-shopping-cart"></i>
              </span>
            </a>
            <ul class="sub-menu">
              <li class="menu-item">
                <router-link to="/procurement/orders" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Procurement Orders</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-file-text"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item" v-if="user.type == 'provider' || user.type == 'provider_employee'">
                <router-link to="/marketplace" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Marketplace</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-shopping-bag"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item" v-if="user.type == 'vendor_employee' || user.type == 'vendor_staff'">
                <router-link to="/vendor/products" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">My Products</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-package"></i>
                  </span>
                </router-link>
              </li>

              <li class="menu-item" v-if="user.type == 'vendor_employee' || user.type == 'vendor_staff'">
                <router-link to="/vendor/account" class="menu-link">
                  <span class="menu-label">
                    <span class="menu-name">Business & Staff</span>
                  </span>
                  <span class="menu-icon">
                    <i class="icon-placeholder fe fe-users"></i>
                  </span>
                </router-link>
              </li>
            </ul>
          </li>
          <!-- Reports: executive summary, system health, facility risk, audit log -->

          <li class="menu-item" v-if="user.type == 'shis' || user.user_role == 1">
            <a href="#" class="open-dropdown menu-link">
              <span class="menu-label">
                <span class="menu-name">Settings
                  <span class="menu-arrow"></span>
                </span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-settings"></i>
              </span>
            </a>
            <ul class="sub-menu">
              <li class="menu-item">
                <router-link to="/agency-settings" class="menu-link">
                  <span class="menu-label"><span class="menu-name">Agency settings</span></span>
                  <span class="menu-icon"><i class="icon-placeholder fe fe-sliders"></i></span>
                </router-link>
              </li>
              <li class="menu-item">
                <router-link to="/manage-plans" class="menu-link">
                  <span class="menu-label"><span class="menu-name">Manage plans</span></span>
                  <span class="menu-icon"><i class="icon-placeholder fe fe-layers"></i></span>
                </router-link>
              </li>
            </ul>
          </li>

          <li class="menu-item" v-if="chatEnabled">
            <router-link to="/messages" class="menu-link">
              <span class="menu-label">
                <span class="menu-name">Messages <span v-if="chatUnread > 0" class="badge badge-pill badge-danger ml-1">{{ chatUnread }}</span></span>
              </span>
              <span class="menu-icon">
                <i class="icon-placeholder fe fe-message-square"></i>
              </span>
            </router-link>
          </li>
        </template>
        </ul>
      </div>
    </aside>

    <Header />
  </div>
</template>

<script>
import chat from "@/chat/store";
import { chatEnabledFor } from "@/chat/config";
  import Header from "@/views/Header.vue";

  export default {
    components: {
      Header,
    },
    computed: {
      dashboardOnly() {
        return !!this.user && this.user.type == "employee" && this.user.job_title == "dashboard";
      },
      chatEnabled() {
        return chatEnabledFor(this.user);
      },
      chatUnread() {
        return chat.state.unread;
      },
    },
    data() {
      return {
        user: null,
        sidebarPinned: false,
        mobileSidebarOpen: false,
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
    },
    mounted() {
      this._bodyObserver = new MutationObserver(() => {
        this.mobileSidebarOpen = document.body.classList.contains("sidebar-open");
      });
      this._bodyObserver.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    },
    beforeDestroy() {
      if (this._bodyObserver) this._bodyObserver.disconnect();
    },
    methods: {},
    created() { },
  };
</script>

<style scoped>
  /* ── Wrapper ─────────────────────────────────────────────── */
  .sidebar-pinned {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    height: 100vh;
  }

  /* ── Sidebar Shell ───────────────────────────────────────── */
  .admin-sidebar {
    background: #ffffff !important;
    border-right: 1px solid #e9ecef !important;
    box-shadow: 2px 0 16px rgba(0, 0, 0, 0.06);
  }

  /* ── Brand / Logo ────────────────────────────────────────── */
  .admin-sidebar-brand {
    background: #f8f9fa !important;
    border-bottom: 1px solid #e9ecef !important;
    padding: 14px 16px !important;
    display: flex;
    align-items: center;
  }

  .admin-brand-logo {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  /* ── Scrollable wrapper ──────────────────────────────────── */
  .admin-sidebar-wrapper {
    overflow-y: auto !important;
    padding: 8px 0 !important;
  }

  /* ── Menu List ───────────────────────────────────────────── */
  .menu {
    padding: 4px 8px !important;
    list-style: none !important;
  }

  .menu-item {
    margin-bottom: 2px;
  }

  /* ── Menu Link ───────────────────────────────────────────── */
  .menu-link {
    display: flex !important;
    align-items: center !important;
    gap: 10px !important;
    padding: 9px 12px !important;
    border-radius: 8px !important;
    color: #4b5563 !important;
    text-decoration: none !important;
    transition: background 0.15s, color 0.15s !important;
    border-left: 3px solid transparent;
  }

  .menu-link:hover {
    background: #f0f4ff !important;
    color: #1e3a5f !important;
    text-decoration: none !important;
  }

  .menu-item.active>.menu-link {
    background: #eef2ff !important;
    color: #1e40af !important;
    border-left-color: #2563eb !important;
    font-weight: 600;
  }

  /* ── Icon — pulled to the left via order ─────────────────── */
  .menu-icon {
    order: -1 !important;
    flex-shrink: 0 !important;
    width: 26px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 15px !important;
    color: #9ca3af !important;
    transition: color 0.15s;
  }

  .menu-link:hover .menu-icon,
  .menu-item.active>.menu-link .menu-icon {
    color: #2563eb !important;
  }

  /* ── Label & Name ────────────────────────────────────────── */
  .menu-label {
    flex: 1 !important;
    min-width: 0 !important;
  }

  .menu-name {
    font-size: 0.82rem !important;
    font-weight: 500 !important;
    letter-spacing: 0.01em !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: block !important;
  }

  /* ── Dropdown arrow ──────────────────────────────────────── */
  .menu-arrow {
    font-size: 0.65rem;
    margin-left: 4px;
    opacity: 0.5;
  }

  /* ── Submenu ─────────────────────────────────────────────── */
  .sub-menu {
    background: #f8f9fa !important;
    border-radius: 8px !important;
    margin: 2px 0 4px 0 !important;
    padding: 4px 0 !important;
    list-style: none !important;
  }

  .sub-menu .menu-link {
    padding: 7px 10px 7px 14px !important;
    border-radius: 6px !important;
    color: #6b7280 !important;
    border-left-color: transparent !important;
  }

  .sub-menu .menu-link:hover {
    background: #eef2ff !important;
    color: #1e3a5f !important;
  }

  .sub-menu .menu-icon {
    font-size: 13px !important;
    width: 20px !important;
  }

  /* ── pin / close buttons ─────────────────────────────────── */
  .admin-pin-sidebar,
  .admin-close-sidebar {
    opacity: 0.5;
    transition: opacity 0.15s;
  }

  .admin-pin-sidebar:hover,
  .admin-close-sidebar:hover {
    opacity: 1;
  }

  /* ── Collapsed: hide labels, center icons ─────────────────── */
  .admin-sidebar:not(:hover):not(.sidebar--pinned):not(.sidebar--mobile-open) .menu-label,
  .admin-sidebar:not(:hover):not(.sidebar--pinned):not(.sidebar--mobile-open) .sub-menu,
  .admin-sidebar:not(:hover):not(.sidebar--pinned):not(.sidebar--mobile-open) .brand-controls {
    display: none !important;
  }

  .admin-sidebar:not(:hover):not(.sidebar--pinned):not(.sidebar--mobile-open) .menu-link {
    justify-content: center !important;
    gap: 0 !important;
  }

  .admin-sidebar:not(:hover):not(.sidebar--pinned):not(.sidebar--mobile-open) .admin-sidebar-brand {
    justify-content: center !important;
  }

  /* ── Expanded: hover, pinned, or mobile-open — restore layout ── */
  .admin-sidebar:hover .menu-label,
  .admin-sidebar.sidebar--pinned .menu-label,
  .admin-sidebar.sidebar--mobile-open .menu-label,
  .admin-sidebar:hover .brand-controls,
  .admin-sidebar.sidebar--pinned .brand-controls,
  .admin-sidebar.sidebar--mobile-open .brand-controls {
    display: block !important;
  }

  .admin-sidebar:hover .menu-link,
  .admin-sidebar.sidebar--pinned .menu-link,
  .admin-sidebar.sidebar--mobile-open .menu-link {
    justify-content: flex-start !important;
    gap: 10px !important;
  }

  .admin-sidebar:hover .admin-sidebar-brand,
  .admin-sidebar.sidebar--pinned .admin-sidebar-brand,
  .admin-sidebar.sidebar--mobile-open .admin-sidebar-brand {
    justify-content: flex-start !important;
  }
</style>